import { render, staticRenderFns } from "./SkeletonScreen.vue?vue&type=template&id=135652b2&scoped=true"
import script from "./SkeletonScreen.vue?vue&type=script&lang=js"
export * from "./SkeletonScreen.vue?vue&type=script&lang=js"
import style0 from "./SkeletonScreen.vue?vue&type=style&index=0&id=135652b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135652b2",
  null
  
)

export default component.exports